import React, { useState, useEffect } from "react";
import { Calendar, Clock, AlertCircle } from "lucide-react";

const urlInfo =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vTF6tTLAnnTKC5MGTwlTrJMZ4ej93FgVYa95oKl3vKi1v1slUdAa4jzSEe5Kd5jwJhKlC35YabRFL8r/pub?gid=86557158&single=true&output=csv";

const Operasional: React.FC = () => {
  const [schedule, setSchedule] = useState<{ day: string; time: string }[]>([]);
  const [loading, setLoading] = useState(true);
  const [opStatus, setOpStatus] = useState({
    label: "Memuat...",
    color: "bg-slate-400",
    icon: <Clock size={12} />,
  });

  useEffect(() => {
    const element = document.getElementById("status-badge");
    if (element) {
      const style = window.getComputedStyle(element);
      console.log("Status saat ini:", opStatus.label);
      console.log("Class yang terpasang:", element.className);
      console.log(
        "Warna Background Sesungguhnya (RGB):",
        style.backgroundColor,
      );
    }
  }, [opStatus]); // Akan jalan setiap kali status berubah

  useEffect(() => {
    const fetchOperasional = async () => {
      try {
        const response = await fetch(urlInfo);
        const csvText = await response.text();
        const rows = csvText.split("\n").filter((row) => row.trim() !== "");

        // Bersihkan headers
        const headers = rows[0]
          .split(",")
          .map((h) => h.trim().replace(/[^\w]/gi, "_"));

        const data = rows.slice(1).map((row) => {
          const values = row.split(",");
          const obj: any = {};
          headers.forEach((header, i) => {
            obj[header] = values[i]?.trim();
          });
          return obj;
        });

        // Cari data jadwal
        const foundJadwal = data.find(
          (item) =>
            item.Kategori === "Operasional" && item.Nama_Key === "Jam Buka",
        );

        if (foundJadwal) {
          const jamInfo = foundJadwal.Detail_Informasi || "11.00 - 22.00";

          // --- LOGIKA STATUS BUKA/TUTUP ---
          const now = new Date();
          const currentTotalMinutes = now.getHours() * 60 + now.getMinutes();

          const parseToMinutes = (timeStr: string) => {
            // Mengatasi format 11.00 atau 11:00
            const parts = timeStr.replace(".", ":").split(":");
            const h = parseInt(parts[0], 10);
            const m = parseInt(parts[1] || "0", 10);
            return h * 60 + m;
          };

          const [startStr, endStr] = jamInfo.split("-").map((s) => s.trim());
          const startTotal = parseToMinutes(startStr);
          const endTotal = parseToMinutes(endStr);

          if (
            currentTotalMinutes >= startTotal &&
            currentTotalMinutes < endTotal
          ) {
            setOpStatus({
              label: "Buka",
              color: "bg-emerald-500 ring-2 ring-white/20", // Hijau dengan ring putih tipis
              icon: <Clock size={12} />,
            });
          } else {
            setOpStatus({
              label: "Tutup",
              color: "bg-red-600 ring-2 ring-white/10",
              icon: <AlertCircle size={12} />,
            });
          }

          const days = [
            "Senin",
            "Selasa",
            "Rabu",
            "Kamis",
            "Jumat",
            "Sabtu",
            "Minggu",
          ];
          setSchedule(days.map((day) => ({ day, time: jamInfo })));
        }
      } catch (error) {
        console.error("Gagal memuat:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOperasional();
  }, []);

  if (loading)
    return (
      <div className="h-64 flex items-center justify-center font-bold text-slate-400">
        Loading..
      </div>
    );

  return (
    <section className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-slate-100 flex flex-col md:flex-row">
          {/* Sisi Kiri - Background Merah */}
          <div className="p-8 sm:p-12 md:w-2/5 bg-[#ee1d23] text-white flex flex-col justify-center gap-6">
            <Calendar size={32} />
            <h3 className="text-3xl font-serif font-black">Jam Operasional</h3>

            {/* Bagian Status yang diperbaiki warnanya */}
            <div
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full ${opStatus.color} text-white text-[10px] font-black uppercase tracking-widest w-fit shadow-xl transition-all duration-500`}
            >
              {opStatus.icon} {opStatus.label}
            </div>
          </div>

          {/* Sisi Kanan - List Jadwal */}
          <div className="p-8 sm:p-12 md:w-3/5 flex flex-col justify-center">
            <div className="space-y-4">
              {schedule.map((item, idx) => {
                const today = new Date().getDay();
                const isToday = idx === (today === 0 ? 6 : today - 1);

                return (
                  <div
                    key={idx}
                    className={`flex justify-between items-center py-3 border-b border-slate-100 px-2 ${isToday ? "bg-amber-50 rounded-xl text-[#ee1d23] font-black border-transparent scale-[1.02]" : "text-slate-600"}`}
                  >
                    <span className="text-sm font-bold uppercase tracking-wider">
                      {item.day}
                    </span>
                    <span className="text-sm font-black">{item.time}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Operasional;
